<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>Edit Order</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleConfirm">Update</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          class="box">

          <div class="form form1">
            <div class="item">
              <span class="item-title">Relationship</span>
              <el-form-item>
                <v-select
                  v-model="formData.rel"
                  disabled
                  :list="localAllOptions.relation"
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Phone No.</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  :disabled="formData.rel==1"
                  type="number"
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Flight No.</span>
              <el-form-item
                ref="flight_no"
                :rules="rules.input"
                prop="flight_no">
                <v-flight-no
                  v-model="formData.flight_no"
                ></v-flight-no>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Flight Ticket</span>
              <el-form-item
                ref="flight_ticket_pic_path_id"
                :rules="rules.upload"
                prop="flight_ticket_pic_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.flight_ticket_pic"
                  :otherData="{
                    target: 'flight_ticket_pic',
                    idKey: 'flight_ticket_pic_path_id',
                    nameKey: 'flight_ticket_pic_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
          </div>

        </div>
      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleConfirm">Confirm</v-button>
      </div>
    </div>
    <aside>
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addFlightDelayRemark,editFlightDelay} from '@/api/flightDelay'
import VFlightNo from './component/v-flight-no'
export default {
  name: 'flightDelayForm',
  components:{
    VFlightNo
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    from:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    },
    id:{
      type:[Number,String],
      default:''
    },
  },
  data () {
    return {
      formData:{
        flight_no:'',
        mobile_no:'',
        flight_ticket_pic_path_id:'',
        flight_ticket_pic:{},
        flight_ticket_pic_path:'',
        flight_ticket_pic_thumb_url:'',
        other_file:[],
        rel:''
      },
      message:'',
      remarkList: [],
      is_send:0,
      extraRules: {
        need_ind: [
          {required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur']},
        ],
      }
    }
  },
  computed:{
    localAllOptions() {
      return this.allOptions23
    },
    remarkLogsData(){
      return this.remarkList||[]
    },
    customerId() {
      return this.$route.query.customer_id
    },
  },
  watch:{
    from:{
      immediate:true,
      handler(val){
        if(val)
        {
          Object.keys(this.formData).some((key) => {
            if (key in val) {
              this.formData[key] = val[key]
            }
          })
          let {flight_ticket_pic={}} = val||{}
          let {id,path,thumb_url} = flight_ticket_pic||{}
          this.formData.flight_ticket_pic_path_id = id
          this.formData.flight_ticket_pic_path= path
          this.formData.flight_ticket_pic_thumb_url= thumb_url
        }
      }
    }
  },
  mounted(){
    this.remarkList = this.remark
  },
  methods: {
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type, } = otherData
      const { id, path,name ,url,client_name} = data
      if(type !== 'other') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }

    },

    handlerDeleteFile({otherData}) {
      const { idKey, nameKey, target, index = '', type, } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, nameKey, '')
      this.$set(this.formData, target, '')

    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.handleSubscribeSend(params)
    },
    handleCancel(){
      this.$emit('cancel')
    },
    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleConfirm(){

      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().editFlightDelay()
        }

      })
    },
    network() {
      return {
        editFlightDelay: async (params) => {
          const { data } = await editFlightDelay({
            id: this.id,
            ...this.formData,
            num:this.from.num
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$emit('success')
        },
        addAccountRemark: async () => {
          const {data} = await addFlightDelayRemark({
            id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
